export default {

    methods: {

        getPhoneTypeDirForDevice(isAppsSourceDevice = false, chosenAppSource = 'system') {

            let self = this

            if (chosenAppSource === 'common' && isAppsSourceDevice) {
                return 'common'
            }

            const phoneTypeIndex = self.phoneTypes.findIndex((phoneType) => {
                return phoneType.key === self.chosenModel;
            })

            if (phoneTypeIndex > -1) {
                return self.phoneTypes[phoneTypeIndex].value.dir
            }

        }
    }
}
